import type { ExperienceAggregations } from '@/shared/api/experience';
import type { IExperienceAggregations } from './types.ts';

type PriceAggregationSource = ExperienceAggregations['price'] | ExperienceAggregations['display_prices'];

export const mapPriceAggregation = (
  source: PriceAggregationSource | null | undefined,
): IExperienceAggregations['price'] => {
  if (!source) {
    return null;
  }

  const priceWithDefaults = source as NonNullable<ExperienceAggregations['price']>;

  return {
    personsCount: source.persons_count ?? null,
    histogramInterval: source.histogram_interval ?? null,
    histogram: source.histogram || null,
    defaultHistogram: priceWithDefaults.defaultHistogram || source.histogram || null,
    range: source.range || null,
    defaultRange: priceWithDefaults.defaultRange || source.range || null,
  };
};

export const resolvePriceAggregationSource = (
  data: ExperienceAggregations,
): PriceAggregationSource | null | undefined => {
  return data.display_prices ?? data.price;
};
